/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiCampaignsMessageType = (typeof GetApiCampaignsMessageType)[keyof typeof GetApiCampaignsMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCampaignsMessageType = {
    SMS: 'SMS',
    EMAIL: 'EMAIL',
} as const;
